// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PK8n","select":"styles_select__jrPJA"};